import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccueilEtablissementComponent } from './accueil-etablissement/accueil-etablissement.component';
import { CandidaturesComponent } from './candidatures/candidatures.component';
import { MonEtablissementComponent } from './mon-etablissement/mon-etablissement.component';
import { PlanningComponent } from './planning/planning.component';
import { MissionsComponent } from './missions/missions.component';
import { MissionValidationComponent } from './missions/mission-validation/mission-validation.component';
import {AddMissionComponent} from "./missions/add-mission/add-mission.component";
import {ProfileComponent} from "./profile/profile.component";

const routes: Routes = [
  {
    path: 'accueil',
    component: AccueilEtablissementComponent,
  },
  {
    path: 'profile',
    component: ProfileComponent,
  },
  {
    path: 'candidatures',
    component: CandidaturesComponent,
  },
  {
    path: 'missions',
    component: MissionsComponent,
    data: { breadcrumb: {alias: 'Missions'} },
    children: [
      {
        path: "add",
        component: AddMissionComponent,
        data: { breadcrumb: {alias: 'add'} },
      },
      {
        path: "add/:id",
        component: AddMissionComponent,
        data: { breadcrumb: {alias: 'modify'} },
      },
      // {
      //   path: "validation/:id",
      //   component: MissionValidationComponent,
      //   data: { breadcrumb: {alias: 'Validation'} },
      // },
    ]
  },
  {
    path: 'planning',
    component: PlanningComponent,
  },
  {
    path: 'etablissement',
    component: MonEtablissementComponent,
  },
  // {path : 'dashboard/**' , redirectTo : '/accueil' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers:[]
})
export class EtablissementRoutingModule {}
